export default {"src":"/_next/static/media/spinach.61e950ef.svg","height":35,"width":62,"blurWidth":0,"blurHeight":0};